import { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import NovaSolicitacaoContent from '../../NovaSolicitacaoPage/NovaSolicitacaoContent';
import type { ValoresIniciaisNovaSolicitacao } from '../../NovaSolicitacaoPage/novaSolicitacaoContent.types';

interface NovaSolicitacaoDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  onCriada: (solicitacaoId: string) => void;
  /** Prefill vindo de fora (ex.: Alocações) — ver NovaSolicitacaoContent. */
  valoresIniciais?: ValoresIniciaisNovaSolicitacao;
}

/**
 * Painel lateral (drawer) para criar uma nova Solicitação sem sair da lista — mesmo
 * padrão do SolicitacaoDrawer (detalhe/execução). A rota `/si/nova` continua existindo
 * e funcionando (NovaSolicitacaoPage), este é só um atalho a partir da lista.
 */
export default function NovaSolicitacaoDrawer({
  isOpen,
  onClose,
  onCriada,
  valoresIniciais,
}: NovaSolicitacaoDrawerProps) {
  return (
    <Transition show={isOpen} as={Fragment}>
      <Dialog onClose={onClose} className="relative z-50">
        <Transition.Child
          as={Fragment}
          enter="transition-opacity ease-linear duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity ease-linear duration-300"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
        </Transition.Child>

        <div className="fixed inset-0 flex justify-end">
          <Transition.Child
            as={Fragment}
            enter="transition ease-in-out duration-300 transform"
            enterFrom="translate-x-full"
            enterTo="translate-x-0"
            leave="transition ease-in-out duration-300 transform"
            leaveFrom="translate-x-0"
            leaveTo="translate-x-full"
          >
            <Dialog.Panel className="flex h-full w-full max-w-2xl flex-col overflow-hidden bg-white shadow-xl">
              <div className="flex flex-shrink-0 items-center justify-end border-b border-gray-200 p-4">
                <button type="button" className="text-gray-400 hover:text-gray-500" onClick={onClose}>
                  <span className="sr-only">Fechar</span>
                  <XMarkIcon className="h-6 w-6" />
                </button>
              </div>
              <div className="flex-grow overflow-y-auto">
                {isOpen && (
                  <NovaSolicitacaoContent
                    onCriada={onCriada}
                    onCancelar={onClose}
                    valoresIniciais={valoresIniciais}
                  />
                )}
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}
